import {
  initAppInsights,
  trackEvent,
  trackException,
  trackPageView,
  setAuthenticatedUserContext,
} from '../services/appInsights'

export default {
  install(Vue, options = {}) {
    const appInsights = initAppInsights(options.connectionString)

    // Add to Vue prototype for easier access in components
    Vue.prototype.$appInsights = {
      trackEvent,
      trackException,
      trackPageView,
      setAuthenticatedUserContext,
      instance: appInsights,
    }

    // Global error handler to track unhandled exceptions
    Vue.config.errorHandler = (error, vm, info) => {
      // Track the error
      trackException(error)

      // Log to console
      console.error('Vue error:', error)
      console.error('Component:', vm)
      console.error('Info:', info)
    }
  },
}
